import { StyledTextArea } from 'components/form-components/styled-text-area'
import PropTypes from 'prop-types'
import React from 'react'
import { validators } from 'utils/form'

const { isRequired } = validators

const propTypes = {
  field: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    fieldSetup: PropTypes.shape({ required: PropTypes.bool }).isRequired,
  }).isRequired,
  noValidation: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
}

export function Textarea({ field, noValidation, onChange }) {
  return (
    <StyledTextArea
      className="resize-vertical"
      model={`.${field._id}`}
      name={`${field._id}`}
      rows={5}
      onBlur={event => onChange(event.target.value)}
      validators={
        field.fieldSetup.required && !noValidation ? { isRequired } : null
      }
    />
  )
}

Textarea.propTypes = propTypes

export default Textarea
